<template>
  <v-list height="300" width="400px" class="overflow-y-auto">
    <v-list-item v-for="index in 4" :key="index">
      <v-list-item-content>
        <v-skeleton-loader type="sentences"></v-skeleton-loader>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "SensorIssuesLoading",
};
</script>